// Editorial author registry. Attribution must always reflect the ACTUAL editorial
// process — no invented credentials (no attorney/medical/licensed claims).
import { SITE_URL } from "./site";

export const AUTHORS = {
  "aaron-bankhurst": {
    slug: "aaron-bankhurst",
    name: "Aaron Bankhurst",
    role: "Founder & Editor",
    bio:
      "Aaron Bankhurst is the founder and editor of Indiana Accident Aid, where he oversees " +
      "research, content development, and editorial standards for Indiana accident and injury resources.",
    isFounder: true,
  },
};

export const DEFAULT_AUTHOR_SLUG = "aaron-bankhurst";
export const DEFAULT_AUTHOR_NAME = AUTHORS[DEFAULT_AUTHOR_SLUG].name;

export function authorByName(name) {
  if (!name) return null;
  return Object.values(AUTHORS).find((a) => a.name === name) || null;
}

export function authorUrl(slug) {
  return `${SITE_URL}/authors/${slug}`;
}
